<template>
  <div>
    <div
      v-for="tab in tabs"
      :key="tab.id"
      v-show="tab.id === selected"
      :data-test="`slot-${tab.id}`"
    >
      <slot :name="tab.id" />
    </div>
  </div>
</template>

<script>
// @ts-check
import { defineComponent } from 'vue';

/** @typedef {Omit<import('@/components/library/tabs/TabItem').TTab, 'selected'>} TTab */

export default defineComponent({
  props: {
    /** @type {import('vue').PropOptions<TTab[]>} */
    tabs: {
      type: Array,
      required: true,
    },
    selected: {
      type: String,
      required: true,
    },
  },
});
</script>
